<template>
  <div>
    <div class="header">
      <div class="container-fluid">

        <b-row class="align-items-center mt-3 mb-2">
          <b-col>
            <span class="text-muted" v-if="categoriasFiltradas.length !== categorias.length">
              {{ categoriasFiltradas.length }} / {{ categorias.length }} {{ $t('catimg_categorias') }}
            </span>
            <span class="text-muted" v-else>{{ categorias.length }} {{ $t('catimg_categorias') }}</span>
            <span class="text-muted ml-2" style="font-size:.8rem;">({{ conImagen }} {{ $t('catimg_con_imagen') }})</span>
          </b-col>
          <b-col class="text-right">
            <button class="btn btn-sm btn-success" @click="exportarExcel" :disabled="!categoriasFiltradas.length" :title="$t('exportar_excel')">
              <i class="fas fa-file-excel mr-1" aria-hidden="true"></i>
              XLS
            </button>
          </b-col>
        </b-row>

        <b-alert variant="info" show class="mb-2">
          <i class="fas fa-info-circle mr-1"></i>
          {{ $t('catimg_alert_pre') }} <strong>imagenes/ImagenesCategorias</strong> {{ $t('catimg_alert_post') }}
        </b-alert>

        <b-alert variant="danger" :show="!!error" dismissible @dismissed="error = ''">
          {{ error }}
        </b-alert>

        <div v-if="cargando" class="text-center text-muted mt-5">
          <b-spinner variant="primary" />
        </div>

        <div v-else-if="categorias.length" class="card shadow" style="margin-bottom: 60px;">
          <div class="tabla-scroll-fixed" ref="tablaCategorias">
            <table class="table table-hover align-items-center mb-0 tabla-compacta">
              <thead class="thead-sticky thead-light">
                <tr>
                  <th class="th-ordenable" @click="ordenarPor('categoria')">
                    <input class="th-search-input" v-model="filterCol.categoria" @click.stop :placeholder="$t('buscar') + '…'" />
                    <span class="th-label">{{ $t('categoria') }} <i :class="iconoOrden('categoria')"></i></span>
                  </th>
                  <th class="th-ordenable" @click="ordenarPor('clase')">
                    <input class="th-search-input" v-model="filterCol.clase" @click.stop :placeholder="$t('buscar') + '…'" />
                    <span class="th-label">{{ $t('clase') }} <i :class="iconoOrden('clase')"></i></span>
                  </th>
                  <th class="th-ordenable" @click="ordenarPor('segmento')">
                    <input class="th-search-input" v-model="filterCol.segmento" @click.stop :placeholder="$t('buscar') + '…'" />
                    <span class="th-label">{{ $t('segmento') }} <i :class="iconoOrden('segmento')"></i></span>
                  </th>
                  <th class="th-ordenable" @click="ordenarPor('familia')">
                    <input class="th-search-input" v-model="filterCol.familia" @click.stop :placeholder="$t('buscar') + '…'" />
                    <span class="th-label">{{ $t('familia') }} <i :class="iconoOrden('familia')"></i></span>
                  </th>
                  <th style="width:120px;">{{ $t('catimg_imagen_col') }}</th>
                  <th style="width:220px;"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in categoriasPaginadas" :key="`${item.categoria}-${item.clase}-${item.segmento}-${item.familia}`">
                  <td>{{ item[campo('categoria')] }}</td>
                  <td>{{ item[campo('clase')] }}</td>
                  <td>{{ item[campo('segmento')] }}</td>
                  <td>{{ item[campo('familia')] }}</td>
                  <td>
                    <img v-if="item.urlImagenCategoria" :src="item.urlImagenCategoria" alt="img"
                      style="height:42px;width:42px;object-fit:cover;border-radius:6px;border:1px solid #e8ecf0;cursor:pointer;"
                      @click="abrirPreview(item)" />
                    <span v-else class="text-muted" style="font-size:.8rem;">{{ $t('catimg_sin_imagen') }}</span>
                  </td>
                  <td class="text-center">
                    <b-button v-if="puedeEditar" size="sm" :variant="item.urlImagenCategoria ? 'outline-info' : 'primary'"
                      :disabled="subiendo === item.categoria" @click="seleccionarArchivo(item.categoria)">
                      <b-spinner small v-if="subiendo === item.categoria" />
                      <span v-else>
                        <i class="fas fa-upload mr-1"></i>
                        {{ item.urlImagenCategoria ? $t('catimg_cambiar_imagen') : $t('catimg_subir_imagen') }}
                      </span>
                    </b-button>
                    <span v-else class="text-muted" style="font-size:.8rem;">-</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div v-else-if="!cargando" class="text-center text-muted mt-5">
          <i class="fas fa-image fa-3x mb-3"></i>
          <p>{{ $t('catimg_no_hay_categorias') }}</p>
        </div>

        <!-- input de archivo oculto, compartido -->
        <input ref="fileInput" type="file" accept="image/*" style="display:none" @change="onArchivo" />

        <b-modal id="modal-preview-imagen" :title="previewTitulo" hide-footer centered size="lg">
          <div class="text-center">
            <img :src="previewUrl" class="img-fluid rounded" style="max-height:70vh;" />
          </div>
        </b-modal>

        <div class="pagination-floating-bar" v-if="categorias.length">
          <div class="d-flex align-items-center">
            <label class="mr-2 mb-0 text-secondary" style="font-size:.85rem;">{{ $t('catimg_items_pag') }}</label>
            <select v-model.number="pageSize" @change="currentPage = 1" class="form-control form-control-sm" style="width:70px;">
              <option :value="20">20</option>
              <option :value="50">50</option>
              <option :value="100">100</option>
              <option :value="999999">{{ $t('catimg_todas') }}</option>
            </select>
          </div>
          <div class="d-flex align-items-center" style="gap:12px;">
            <button class="btn btn-outline-secondary btn-sm" :disabled="currentPage === 1" @click="currentPage--">
              <i class="fas fa-arrow-left mr-1"></i> {{ $t('anterior') }}
            </button>
            <span style="font-weight:600;color:#6c757d;font-size:.9rem;">
              {{ $t('pagina') }} {{ currentPage }} {{ $t('de') }} {{ totalPages }}
              <span class="text-muted ml-2" style="font-size:.8rem;">({{ categoriasFiltradas.length }} {{ $t('resultados') }})</span>
            </span>
            <button class="btn btn-outline-primary btn-sm" :disabled="currentPage >= totalPages" @click="currentPage++">
              {{ $t('siguiente') }} <i class="fas fa-arrow-right ml-1"></i>
            </button>
          </div>
          <div class="d-flex align-items-center" style="gap:6px;">
            <button class="btn btn-sm btn-scroll-nav" @click="scrollTabla('top')" :title="$t('catimg_ir_inicio')"><i class="fas fa-chevron-up"></i></button>
            <button class="btn btn-sm btn-scroll-nav" @click="scrollTabla('bottom')" :title="$t('catimg_ir_final')"><i class="fas fa-chevron-down"></i></button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import categoriaImagenService from '@/api/categoriaImagenService';
import utilsService from '@/api/utilsService';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';

export default {
  name: 'CategoriaImagenView',
  data() {
    return {
      categorias: [],
      cargando: false,
      error: '',
      ordenColumna: null,
      ordenDireccion: 'asc',
      filterCol: { categoria: '', clase: '', segmento: '', familia: '' },
      currentPage: 1,
      pageSize: 50,
      subiendo: null,
      catActual: null,
      previewUrl: null,
      previewTitulo: '',
    };
  },

  watch: {
    filterCol: { deep: true, handler() { this.currentPage = 1; } },
  },

  mounted() {
    this.$store.dispatch('setSidebarCollapsed', false);
    this.cargar();
  },

  beforeDestroy() {
    this.$store.dispatch('setSidebarCollapsed', false);
  },

  computed: {
    puedeEditar() {
      return utilsService.puedeEscribir() && utilsService.getRol() !== 'ventas inex';
    },
    esIngles() {
      return this.$getLanguage() === 'en';
    },
    conImagen() {
      return this.categorias.filter(c => !!c.urlImagenCategoria).length;
    },
    categoriasFiltradas() {
      const fc = this.filterCol;
      let lista = this.categorias;
      if (fc.categoria) lista = lista.filter(c => (c[this.campo('categoria')] || '').toLowerCase().includes(fc.categoria.toLowerCase()));
      if (fc.clase) lista = lista.filter(c => (c[this.campo('clase')] || '').toLowerCase().includes(fc.clase.toLowerCase()));
      if (fc.segmento) lista = lista.filter(c => (c[this.campo('segmento')] || '').toLowerCase().includes(fc.segmento.toLowerCase()));
      if (fc.familia) lista = lista.filter(c => (c[this.campo('familia')] || '').toLowerCase().includes(fc.familia.toLowerCase()));
      return lista;
    },
    categoriasOrdenadas() {
      if (!this.ordenColumna) return this.categoriasFiltradas;
      const sorted = [...this.categoriasFiltradas];
      const campoOrden = this.campo(this.ordenColumna);
      sorted.sort((a, b) => {
        let vA = String(a[campoOrden] || '').toLowerCase();
        let vB = String(b[campoOrden] || '').toLowerCase();
        if (vA < vB) return this.ordenDireccion === 'asc' ? -1 : 1;
        if (vA > vB) return this.ordenDireccion === 'asc' ? 1 : -1;
        return 0;
      });
      return sorted;
    },
    totalPages() {
      if (this.pageSize >= 999999) return 1;
      return Math.max(1, Math.ceil(this.categoriasOrdenadas.length / this.pageSize));
    },
    categoriasPaginadas() {
      if (this.pageSize >= 999999) return this.categoriasOrdenadas;
      const start = (this.currentPage - 1) * this.pageSize;
      return this.categoriasOrdenadas.slice(start, start + this.pageSize);
    },
  },

  methods: {
    campo(base) {
      return this.esIngles ? `${base}Ingles` : base;
    },
    async cargar() {
      try {
        this.cargando = true;
        this.categorias = await categoriaImagenService.getAll();
      } catch (e) {
        this.error = (e && e.message) ? e.message : this.$t('catimg_error_cargar');
      } finally {
        this.cargando = false;
      }
    },
    ordenarPor(col) {
      if (this.ordenColumna === col) {
        this.ordenDireccion = this.ordenDireccion === 'asc' ? 'desc' : 'asc';
      } else {
        this.ordenColumna = col;
        this.ordenDireccion = 'asc';
      }
    },
    iconoOrden(col) {
      if (this.ordenColumna !== col) return 'fas fa-sort text-muted';
      return this.ordenDireccion === 'asc' ? 'fas fa-sort-up' : 'fas fa-sort-down';
    },
    abrirPreview(item) {
      this.previewUrl = item.urlImagenCategoria;
      this.previewTitulo = item[this.campo('categoria')];
      this.$bvModal.show('modal-preview-imagen');
    },
    seleccionarArchivo(categoria) {
      if (!this.puedeEditar) return;
      this.catActual = categoria;
      this.$refs.fileInput.value = '';
      this.$refs.fileInput.click();
    },
    async onArchivo(event) {
      const file = event.target.files && event.target.files[0];
      const categoria = this.catActual;
      if (!file || !categoria) return;

      const idUsuario = localStorage.getItem('user-id') || 0;
      try {
        this.subiendo = categoria;
        Swal.fire({
          html: '<div style="display:flex;align-items:center;justify-content:center;">' +
                '<img src="/img/others/loading.gif" alt="Loading" style="width:50px;height:50px;margin-right:15px;">' +
                `<div><h3 style="color:#006393;">${this.$t('catimg_subiendo_imagen')}</h3></div>` +
                '</div>',
          showConfirmButton: false,
          allowOutsideClick: false,
        });
        const response = await categoriaImagenService.subir(categoria, file, idUsuario);
        const data = response && response.data ? response.data : null;
        const url = data && data.urlImagenCategoria ? data.urlImagenCategoria : null;

        // Actualiza todas las filas de esa categoría en memoria (puede repetirse por Clase/Segmento/Familia)
        // con timestamp para refrescar la miniatura al sobrescribir
        if (url) {
          this.categorias
            .filter(c => c.categoria === categoria)
            .forEach(row => { row.urlImagenCategoria = url + '?t=' + Date.now(); });
        }

        Swal.fire({ title: this.$t('catimg_imagen_subida_ok'), icon: 'success', showConfirmButton: false, timer: 1800 });
      } catch (error) {
        const raw = (error && error.response) ? error.response.data : error;
        let msg = this.$t('catimg_error_subir');
        if (typeof raw === 'string') msg = raw;
        else if (raw && raw.message) msg = raw.message;
        else if (error && error.message) msg = error.message;
        Swal.fire({ icon: 'error', title: 'Oops...', text: msg });
      } finally {
        this.subiendo = null;
        this.catActual = null;
      }
    },
    scrollTabla(dir) {
      const el = this.$refs.tablaCategorias;
      if (!el) return;
      if (dir === 'top') el.scrollTo({ top: 0, behavior: 'smooth' });
      if (dir === 'bottom') el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' });
    },
    exportarExcel() {
      const rows = this.categoriasOrdenadas;
      if (!rows.length) { Swal.fire({ icon: 'info', title: this.$t('no_filas_exportar') }); return; }

      const cols = [
        { key: this.campo('categoria'), label: this.$t('categoria') },
        { key: this.campo('clase'), label: this.$t('clase') },
        { key: this.campo('segmento'), label: this.$t('segmento') },
        { key: this.campo('familia'), label: this.$t('familia') },
        { key: 'urlImagenCategoria', label: this.$t('catimg_imagen_col') },
      ];
      const header = cols.map(c => c.label);
      const data = [header, ...rows.map(r => cols.map(c => r[c.key] == null ? '' : r[c.key]))];
      const ws = XLSX.utils.aoa_to_sheet(data);
      ws['!cols'] = header.map(h => ({ wch: Math.max(10, String(h).length + 2) }));
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Categorias');
      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([wbout], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      const fecha = new Date().toISOString().slice(0, 10);
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `ImagenesCategorias_${fecha}.xlsx`;
      document.body.appendChild(a);
      a.click();
      setTimeout(() => { document.body.removeChild(a); URL.revokeObjectURL(url); }, 0);
    },
  },
};
</script>

<style scoped>
.tabla-compacta td {
  font-size: 12px;
  padding: 6px 8px;
}
.th-ordenable {
  cursor: pointer;
  user-select: none;
  vertical-align: top;
  white-space: nowrap;
}
.th-ordenable:hover {
  background-color: #e9ecef !important;
}
.th-search-input {
  width: 100%;
  font-size: 10px;
  padding: 2px 4px;
  border: 1px solid #ced4da;
  border-radius: 3px;
  margin-bottom: 3px;
  display: block;
  font-weight: normal;
}
.th-label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}
.tabla-scroll-fixed {
  max-height: calc(100vh - 260px);
  overflow: auto;
}
.thead-sticky th {
  position: sticky;
  top: 0;
  z-index: 2;
}
.pagination-floating-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  border-top: 1px solid #e8ecf0;
  padding: 8px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 1000;
  box-shadow: 0 -2px 6px rgba(0,0,0,0.05);
}
.btn-scroll-nav {
  border: 1px solid #dee2e6;
  background: #fff;
  color: #6c757d;
}
</style>
